module.exports = __webpack_public_path__ + "cfffa622ea1464493e872d7dc620adab.jpg";